export default {
  MEGA_MENU_ID: '3DbfMi90kPqYMAbS6gCgwi',
  FOOTER_PLEATS_PANEL_ID: '1ncwzDQHPcpE77e6Wz6Zq3',
  HELP_BLOCK_MICRODATA_BUNCH_ID: '7LQnpO9fa6DODBLMvmzhI',
  PROMO_BANNER_MICRODATA_ITEM_KEY: 'promo-banner',
  CART_UPSELL_PRODUCTS_KEY: 'CartUpsellProducts',
  CHECKOUT_REINSURANCE: '5RzU07UHiu5gFNwrDCXOLy'
};
